<template>
  <div class="add_punch_clock">
    <div class="vx-card p-6">
      <div class="vx-row pt-5 px-5 items-center">
        <!-- select user -->
        <div class="vx-col w-full lg:w-4/12">
          <div class="vx-col">
            <h6 class="mb-2">Employee</h6>
          </div>
          <div class="vx-col">
            <select-2
              class="w-full"
              autocomplete
              :value="employerId"
              @input="(elem) => (employerId = elem.value)"
              placeholder="Please Select Employee"
              name="Employee"
              :options="emplotersOptions"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('Employee')">{{ errors.first('Employee') }}</span>
          </div>
        </div>
      </div>

      <div class="vx-row pt-5 px-5">
        <!-- clock in btn -->
        <div class="vx-col w-full lg:w-4/12">
          <vs-button color="primary" type="filled" :disabled="!validateForm || loading" @click="addPunchClock('In')">Clock In</vs-button>
          <vs-button class="ml-2" color="primary" type="filled" :disabled="!validateForm || loading" @click="addPunchClock('Out')">Clock Out</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Select2 from '@/components/custom/form-elements/Select2.vue'

export default {
  name: 'AddPunchClock',

  components: {
    Select2
  },

  data() {
    return {
      employerId: null,
      emplotersOptions: []
    }
  },

  async mounted() {
    this.$store
      .dispatch('punch_clock/getEmployerList', { page: 1, limit: 0 })
      .then((res) => {
        this.emplotersOptions = res.data.reduce((acc, item) => {
          item.label = item.username
          item.value = item.id
          acc.push(item)

          return acc
        }, [])
      })
      .catch((err) => {
        const { message } = err
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },

  computed: {
    ...mapState('register', ['loading']),

    //   validate form
    validateForm() {
      return !this.errors.any()
    }
  },

  methods: {
    async addPunchClock(status) {
      if (!(await this.$validator.validate())) {
        return false
      }

      this.$store
        .dispatch('punch_clock/addPunchClock', { employerId: this.employerId, action: status })
        .then((res) => {
          this.$router.push('/')

          this.$vs.notify({
            title: 'Success',
            text: res.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  }
}
</script>

<style>
</style>